export const CONNECTION_FORM_LIMIT = 3
